import { ref, onMounted, onUnmounted } from "vue";

export function toNumber(string) {
  return Number(string.replace(/\./g, ""));
};

export function toBoolean(string) {
  if (string === undefined) return false;
  return JSON.parse(string);
};


/**
     * Checks if the current device is a mobile device.
     *
     * Tests the user agent string of the browser against a regular expression
     * that matches common mobile devices. The function returns true, indicating that the current device
     * is a mobile device. Returns false otherwise.
     */
/* export function isMobile() {
  return (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
}; */

// includes small desktop browser window in mobile view
/* export function isMobile() {
  const isUA = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent); //userAgent
  const isSmall = window.innerWidth <= 960;

  return isUA || isSmall;
} */

// checks continuously for changes in userAgent or window size and returns whether mobile View can be used
export function useIsMobile(breakpoint = 960) {
  const isMobile = ref(false);

  const update = () => {
    const isUA =
      /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );

    const isSmall = window.innerWidth <= breakpoint;

    isMobile.value = isUA || isSmall;
  };

  onMounted(() => {
    update();
    window.addEventListener("resize", update);
  });

  onUnmounted(() => {
    window.removeEventListener("resize", update);
  });

  return isMobile;
}
